import { render } from "./RolesManager.vue?vue&type=template&id=59a9314c"
import script from "./RolesManager.vue?vue&type=script&lang=js"
export * from "./RolesManager.vue?vue&type=script&lang=js"

import "./RolesManager.vue?vue&type=style&index=0&id=59a9314c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__